var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_13339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5016 2.43934C15.6969 2.6346 15.6969 2.95118 15.5016 3.14645L14.4587 4.18933L12.4587 2.18933L13.5016 1.14645C13.6969 0.951184 14.0134 0.951185 14.2087 1.14645L15.5016 2.43934Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7516 4.89644L11.7516 2.89644L4.93861 9.70943C4.88372 9.76432 4.84237 9.83123 4.81782 9.90487L4.01326 12.3186C3.94812 12.514 4.13405 12.6999 4.32949 12.6348L6.74317 11.8302C6.81681 11.8057 6.88372 11.7643 6.93861 11.7094L13.7516 4.89644Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14C1 14.8284 1.67157 15.5 2.5 15.5H13.5C14.3284 15.5 15 14.8284 15 14V8C15 7.72386 14.7761 7.5 14.5 7.5C14.2239 7.5 14 7.72386 14 8V14C14 14.2761 13.7761 14.5 13.5 14.5H2.5C2.22386 14.5 2 14.2761 2 14V3C2 2.72386 2.22386 2.5 2.5 2.5H9C9.27614 2.5 9.5 2.27614 9.5 2C9.5 1.72386 9.27614 1.5 9 1.5H2.5C1.67157 1.5 1 2.17157 1 3V14Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_204_13339)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#718096"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyIcon);
export default __webpack_public_path__ + "static/media/modify_icon.01dd9d2bf680b17f9bf04116939f3bf6.svg";
export { ForwardRef as ReactComponent };